<template>
  <div class="submit-rule">
    <div>
      <div class="submit-rule-title">
        2022年明基摄影后期大赛 <br />【投稿细则】及【版权要求】
      </div>
      <p>
        1、本次赛事共设两条赛道：相机赛道、手机赛道。<br />
        2、手机赛道作品必须使用手机拍摄（手机型号不限），由手机拍摄并经过后期处理参与投稿。<br />
        3、每个赛道4个作品类别，分别是：人像、风光、创意与商业、动物（22年特殊单元）。<br />
        4、请选择相应的赛道及单元上传作品，每个单元仅限上传1张作品参赛，每位参赛者总投稿量不超过8张。<br />
        5、热爱摄影的朋友均可免费参加，年龄、国籍、职业不限。<br />
        6、作品不得有任何文字、边框等标记，标题、作品描述中不得透露作者姓名。<br />
        7、作品仅限数码文件，风格不限，但不接受无摄影元素纯粹电脑合成、拼贴的作品。<br />
        8、作品格式为JPG，作品大小3M-10M，投稿成功后会有短信通知。<br />
        9、作品须为参赛者原创，获奖后需调取参赛作品原件或原始RAW文件审核。参赛者若不能证明获奖作品为原创且未按照约定时间内提供或因作者原因（包括但不限于作者提供的电子邮箱、手机号不准确）无法接到通知，主办方将取消作品参赛资格，责任由该作者承担。<br />
        10、参赛者的照片，须拥有照片的著作权并获得参赛照片中所包含人物的肖像权使用许可和其他必要的许可。同时，须保证参赛照片不侵犯任何第三人的著作权、肖像权、名誉权、隐私权、商标权、商号权等其他合法权益，如给主办方造成任何损失，或损害主办方名誉的参赛者，还应赔偿主办方的全部损失。<br />
        11、任何人发现本届摄影大赛照片有侵权嫌疑，请及时与主办方联系。主办方一经接到包括有关照片肖像权、著作权等相关投诉，或者发现投稿作品中包含违反前条规定的内容时，将立即删除相关照片并把相关投诉转送至上传人，由参赛者投稿的照片自行解决相关投诉并承担全部涉及费用。<br />
        12、赛事为免费参与投稿，任何机构或公司未经许可，不得擅自使用本次赛事名义进行宣传收费。<br />
        13、对于含有违反我国法律法规、含有色情或暴力、侵害他人权益、违背社会公序良俗、违反宗教禁忌的作品，主办方有权取消其参赛资格。<br />
        14、参加本次投稿的作品及获奖作品，作者有著作权和署名权，主办方享有使用权，在注明作者的情况下，主办方有权将该作品用于展览、宣传、出版等商业用途。<br />
        15、参赛者须仔细阅读以上条款，一经投稿，即视为同意并遵守以上各条规定，因参赛者个人违反上述条款而导致的法律责任全部由该参赛者本人承担，与主办方无关。<br />
      </p>
      <div class="submit-rule-button">
        <van-button
          round
          size="large"
          type="primary"
          class="button-inline"
          @click="submit"
          :disabled="readSec > 0"
          >{{ readSec > 0 ? `已阅 ${readSec}s` : "已阅" }}</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
let readRuleTimer;
export default {
  components: {},
  props: {},
  data() {
    return {
      readSec: 0,
      readButtonType: "info",
    };
  },
  computed: {},
  watch: {},
  created() {
    this.readSec = 30;
    this.readRuleCountDown();
  },
  mounted() {},
  methods: {
    /**
     * 投稿细则弹窗已阅倒计时
     */
    readRuleCountDown() {
      clearInterval(readRuleTimer);
      readRuleTimer = setInterval(() => {
        if (this.readSec <= 0) {
          clearInterval(readRuleTimer);
        } else {
          this.readSec--;
        }
      }, 1000);
    },
    submit() {
      this.$emit("submit");
    },
  },
};
</script>
<style lang="scss" scoped>
.submit-rule {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 100;
  & > div {
    width: 305px;
    height: 466px;
    background-color: #fff;
    border-radius: 6px;
    margin: 20vh auto auto auto;
    opacity: 1;
    .submit-rule-title {
      text-align: center;
      padding: 30px 25px 15px;
      font-weight: bold;
      font-size: 20px;
    }
    p {
      height: 270px;
      background-color: #ffffff;
      border-radius: 6px;
      line-height: 25px;
      padding: 0px 25px 0px;
      overflow-y: auto;
      font-size: 13px;
      text-align: justify;
    }
    .submit-rule-button {
      width: 255px;
      height: 40px;
      margin: 25px auto 35px;
      .button-inline {
        width: 255px;
        height: 40px;
      }
    }
  }
}
</style>
